module.exports = __webpack_public_path__ + "static/img/ai_info.37a0096b.jpg";